// Corpus-free category definitions — safe for client bundles.
export type TranslationFaqCategory =
  | "certification"
  | "fees"
  | "languages"
  | "documents"
  | "government"
  | "apostille"
  | "corporate";

export interface TranslationCategoryDef {
  slug: TranslationFaqCategory;
  titleTh: string;
  titleEn: string;
  descTh: string;
  descEn: string;
  matchTh: RegExp;
  matchEn: RegExp;
}

export const TRANSLATION_FAQ_CATEGORIES: TranslationCategoryDef[] = [
  {
    slug: "certification",
    titleTh: "ระดับการรับรองคำแปล",
    titleEn: "Certification Tiers",
    descTh: "คำแปลรับรองผู้แปล ทนาย Notarial Services Attorney และนิติกรณ์กรมการกงสุล ต่างกันอย่างไร",
    descEn: "Translator-certified vs notarised vs MFA-legalised translation — which one you need.",
    matchTh: /(รับรอง|นิติกรณ์|ทนาย|notary|ผู้แปล|สาบาน)/i,
    matchEn: /(certif|notar|sworn|legalis|legaliz|attest)/i,
  },
  {
    slug: "fees",
    titleTh: "ค่าแปล ค่าธรรมเนียม และระยะเวลา",
    titleEn: "Fees & Turnaround",
    descTh: "คิดค่าแปลอย่างไร ค่าธรรมเนียม 200/400 บาท และงานด่วนภายใน 1 วัน",
    descEn: "How translation is priced, THB 200/400 government stamps and 1-day express.",
    matchTh: /(ค่า|ราคา|บาท|กี่วัน|ระยะเวลา|ใช้เวลา|ด่วน)/,
    matchEn: /(fee|cost|price|how much|how long|turnaround|baht|thb|express|urgent)/i,
  },
  {
    slug: "languages",
    titleTh: "ภาษาและคู่ภาษา",
    titleEn: "Languages & Language Pairs",
    descTh: "28 ภาษา — ต้องแปลผ่านภาษาอังกฤษก่อนไหม และภาษาที่กงสุลรับรองได้โดยตรง",
    descEn: "28 language pairs, pivot-through-English rules and what the MFA will stamp.",
    matchTh: /(ภาษา|แปลผ่าน|จีน|ญี่ปุ่น|เกาหลี|เยอรมัน|ฝรั่งเศส|รัสเซีย|อาหรับ)/,
    matchEn: /(language|chinese|japanese|korean|german|french|russian|arabic|pivot|english)/i,
  },
  {
    slug: "documents",
    titleTh: "เอกสารที่ต้องเตรียม",
    titleEn: "Required Documents",
    descTh: "ฉบับจริง สำเนารับรอง พาสปอร์ต การสะกดชื่อ และเหตุผลที่ถูกตีกลับ",
    descEn: "Originals, certified copies, passport spelling and the top rejection causes.",
    matchTh: /(เอกสาร|สำเนา|ฉบับจริง|พาสปอร์ต|สะกด|ตีกลับ|บัตรประชาชน)/,
    matchEn: /(document|copy|original|passport|spelling|reject|id card)/i,
  },
  {
    slug: "government",
    titleTh: "ยื่นหน่วยงานราชการไทย",
    titleEn: "Thai Government Filings",
    descTh: "อำเภอ ตม. กรมที่ดิน DBD — แต่ละที่ต้องการคำแปลระดับไหน",
    descEn: "Amphur, Immigration, Land Office and DBD — what each authority accepts.",
    matchTh: /(อำเภอ|ตม\.|ตรวจคนเข้าเมือง|กรมที่ดิน|dbd|ราชการ|สมรส|วีซ่า)/i,
    matchEn: /(amphur|immigration|land office|dbd|government|marriage|visa|work permit)/i,
  },
  {
    slug: "apostille",
    titleTh: "Apostille 2026 และเอกสารจากต่างประเทศ",
    titleEn: "Apostille 2026 & Foreign Documents",
    descTh: "เอกสารต่างประเทศต้อง Apostille ก่อนแปลไหม และลำดับขั้นตอนที่ถูกต้อง",
    descEn: "Whether foreign papers need an Apostille before Thai translation, and in what order.",
    matchTh: /(apostille|เฮก|hague|ต่างประเทศ|สถานทูต)/i,
    matchEn: /(apostille|hague|foreign|embassy|abroad|overseas)/i,
  },
  {
    slug: "corporate",
    titleTh: "เอกสารบริษัทและงานธุรกิจ",
    titleEn: "Corporate & Business Translation",
    descTh: "หนังสือรับรองบริษัท บอจ.5 งบการเงิน สัญญา คำพิพากษา และงานประมูล",
    descEn: "DBD affidavits, shareholder lists, financials, contracts, judgments and tenders.",
    matchTh: /(บริษัท|นิติบุคคล|บอจ|งบการเงิน|สัญญา|คำพิพากษา|ธุรกิจ|ประมูล)/,
    matchEn: /(company|corporate|affidavit|shareholder|financial|contract|judgment|tender|business)/i,
  },
];

export function getTranslationCategoryDef(slug: string): TranslationCategoryDef | undefined {
  return TRANSLATION_FAQ_CATEGORIES.find((c) => c.slug === slug);
}
